import { useUser } from './user_context';

export const useUserInfo = () => {
  const { user, isLoading, setUser, clearUser } = useUser();
  
  return {
    user,
    isLoading,
    setUser,
    clearUser,
    // Convenience properties
    isLoggedIn: !!user,
    userName: user?.profile?.full_name || 
              `${user?.profile?.first_name || ''} ${user?.profile?.last_name || ''}`.trim() || 
              user?.username || 'User',
    userInitial: user?.profile?.first_name ? user.profile.first_name.charAt(0).toUpperCase() : 
                 user?.profile?.full_name ? user.profile.full_name.charAt(0).toUpperCase() : 
                 user?.username ? user.username.charAt(0).toUpperCase() : 'U',
    userAvatar: user?.profile?.image_url
  };
}; 